/*
 * Filename: \src\Settings\Vendors\AddVendor\AcceptTerms.js
 * Created Date: 2025-12-10 13:01
 * Author: jdkohl
 * 
 * Copyright (c) 2025 Logical Developments
 */

import { useAddVendorContext } from "./AddVendorContext";
import useAuthenticate from "../../../Session/useAuthenticate";
import { companyName, freightTermsURL } from "../../../Configuration/Config";
import "./AcceptTerms.css"


export default function AcceptTerms({ termsAccepted, setTermsAccepted }) {
  const { customer } = useAuthenticate();
  const { vendor } = useAddVendorContext();
  
    return (
      <div className="stack">
        <div className="centred-stack" >
          <p>You are about to authorise <strong>{vendor.name}</strong> to book freight on your behalf, subject to the terms and conditions outlined below. Please read these terms and conditions carefully, then click "Accept" to proceed.</p>

          <div className="stack terms-container" >
            <h4>Terms and Conditions</h4>
            <p>
              By adding this vendor, you acknowledge and agree to the following terms:
            </p>
            <ul >
              <li>
                You authorize <strong>{vendor.name}</strong> to book freight on behalf of <strong>{customer.company}</strong> using <strong>{companyName}</strong> as the carrier.
              </li>
              <li>
                The vendor will only be able to send freight to addresses you have nominated.
              </li>
              <li>
                You are responsible for all freight bookings made by this vendor on your behalf.
              </li>
              <li>
                You can revoke this vendor's access at any time by removing them from your vendor list.
              </li>
              <li>
                All bookings made by the vendor will be subject to <strong>{companyName}'s</strong> {freightTermsURL ? <a target="_blank" rel="noreferrer" href={freightTermsURL}>freight terms and conditions</a> : 'freight terms and conditions'}.
              </li>
            </ul>
          </div>
          <div className="label-input__align">
            <input
              type="checkbox"
              id="acceptTerms"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              required
            />
            <label htmlFor="acceptTerms">
              I accept the terms and conditions and authorise <strong>{vendor.name}</strong> to book freight on behalf of <strong>{customer.company}</strong>
            </label>
          </div>
        </div>
      </div>
    );
}